import { Modal } from "@/components/elements/Modal";
import { text } from "@/theme/colors";
import { Typography } from "@mui/material";
import { FC } from "react";

type TVisaLinkRequireFieldModalProps = {
  isOpen: boolean;
  /** 未入力の項目名（例: 登録番号 / 管理番号） */
  fieldLabel: string;
  onClose: () => void;
  /** 「入力画面へ」押下時（編集画面への遷移） */
  onNavigate: () => void;
};

export const VisaLinkRequireFieldModal: FC<TVisaLinkRequireFieldModalProps> = ({ isOpen, fieldLabel, onClose, onNavigate }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onOk={onNavigate}
      title={`${fieldLabel}の入力が必要です`}
      labelClose="キャンセル"
      labelOk="入力画面へ"
      width={500}
    >
      <Typography variant="body14" color={text.secondary}>
        irohana visa と連携するには、{fieldLabel}の入力が必要です。
        <br />
        編集画面から{fieldLabel}を入力してください。
      </Typography>
    </Modal>
  );
};
